export default `
mutation deleteClient($id: ID!, $serviceProviderId: ID!) {
  deleteClient(id: $id, serviceProviderId: $serviceProviderId) {
    id
    serviceProviderId
    updatedAt
    propertyIds
    firstName
    lastName
    email
    isArchived
    isDeleted
  }
}
`;
